import React, { useEffect, useRef } from 'react';
import { MdClose } from 'react-icons/md';
import Portal from '../../ui/Portal';
import styles from './ProductDetailModal.module.css';

// Detalle de producto (catálogo). Va en un Portal a document.body: la tarjeta vive dentro de la grilla
// con scroll y el modal quedaba por debajo del navbar.
const ProductDetailModal = ({ isOpen, onClose, title, children }) => {
  const modalRef = useRef(null);
  const closeButtonRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
      document.addEventListener('keydown', handleKeyDown);
      closeButtonRef.current?.focus();
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <Portal>
      <div className={styles.overlay}>
        <div
          className={`modal-content ${styles.content}`}
          ref={modalRef}
          role="dialog"
          aria-modal="true"
          aria-label={title}
        >
          <button
            type="button"
            ref={closeButtonRef}
            className={styles.close}
            onClick={onClose}
            aria-label="Cerrar"
          >
            <MdClose aria-hidden="true" />
          </button>
          {children}
        </div>
      </div>
    </Portal>
  );
};

export default ProductDetailModal;
